import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    spinner:false
}

const spin = createSlice({
    name:'spin',
    initialState,
    reducers: {
        spinerLog: (state, action) =>{
          console.log(action.payload,'action.payload');
           if(action.payload === true){
            console.log(action.payload,'action.payload');
            
             state.spinner = true;
           }else{
            state.spinner = false;
           }
        }}
})

export const { spinerLog } = spin.actions;
export default spin.reducer;